import { UnitSearchOptions } from "constant/dl_unit/dl_unit.constant";
import { axiosCitajteo } from "../../axios/citajteo_axios";
import { DlUnit } from "model/dl_unit/DlUnit";
import { SearchResult } from "type/common/search/search_result.type";

export const unitGet = async (
  id: string,
  searchBy: string = "id",
): Promise<DlUnit | null> => {
  let result: DlUnit | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.get(`dl-unit/${id}?searchBy=${searchBy}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = new DlUnit(response.data);
  }

  return result;
};

export type UnitSearchParams = Partial<
  Record<UnitSearchOptions, number | string>
>;

const unitResponseFormat = (unit: Partial<DlUnit>): DlUnit => {
  const result = new DlUnit(unit);

  return result;
};

export type UnitSearchResponse = SearchResult<DlUnit>;

export const unitSearch = async (
  searchParams?: UnitSearchParams,
): Promise<UnitSearchResponse | null> => {
  let result: UnitSearchResponse | null = null;
  let response: any;
  try {
    response = await axiosCitajteo.post(`dl-unit/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    if (result !== null) {
      result.items = result.items.map((item: any) => unitResponseFormat(item));
    }
  }

  return result;
};
